var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('div',{staticClass:"container"},[_c('TemplatePageGrid',{attrs:{"items":_vm.SettingWorkDocsWorkAreaPage ? _vm.workClientProjectGrid : _vm.workDocsWorkAreaGrid_project,"page-data":_vm.pageData,"loading":_vm.loadingAnimation,"sort-az":"last_name"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [(
            !_vm.SettingWorkDocsWorkAreaPage &&
            _vm.$userCheckAccess({
              abilities: 'edit_document_types',
            })
          )?_c('WorkDocsWorkAreaModal',{attrs:{"create":true}}):_vm._e()]},proxy:true}])},[_c('WorkDocsWorkAreaTable',{attrs:{"items":_vm.SettingWorkDocsWorkAreaPage ? _vm.workClientProjectGrid : _vm.workDocsWorkAreaGrid_project}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }